<template>
    <div id="wrapper-contendor-principal" :class="(!conEstilosClaros) ? 'contenedor-color-negro container-fluid p-0' : 'contenedor-color-claro container-fluid p-0'">
        <div v-if="(conTitulo) ? conTitulo : informacionDePunteroCompleta && puedeRealizarAccion" :class="(conEstilosClaros) ? 'titulo-contenedores-claro' : 'titulo-contenedores'">
            <h5 v-if="conTitulo" class="font-weight-bold"><i class="fas fa-search"></i>&nbsp;&nbsp;Filtros de búsqueda</h5>
            <div v-if="informacionDePunteroCompleta && puedeRealizarAccion" id="puntero-de-seleccion-info" class="alert alert-dark mt-3">
                <ul>
                    <li><div>{{ catalogoAreas.seleccionada.Nombre }}</div>
                        <ul>
                            <li><div>{{ catalogoPaginas.seleccionada.Titulo }}</div>
                                <ul>
                                    <li><div>{{ catalogoSeccion.seleccionada.Nombre }}</div>
                                        <!-- agregar si llegara a existir mas de una seccion hija en bd
                                            <CArbolDeSeleccion v-if="obtenerSeccionesHijas.length > 0"
                                            :listaAObjetoArbol="{ covertir: true, lista: obtenerSeccionesHijas }"
                                            :identificadoresObjeto="{ hijo: 'hijo', texto: 'texto' }"></CArbolDeSeleccion> -->

                                        <ul v-if="this.campoRequeridoEsValido(this.catalogoSeccion.hijos.seleccionado)">
                                            <li><div>{{ this.catalogoSeccion.hijos.seleccionado.Nombre }}</div></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="container-fluid pt-3 pr-4 pb-3 pl-4">
            <div id="contenedor-principal-filtros" class="row">
                <!-- AREA DEL CONTENIDO -->
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-1">
                     <h6 style="p-3">Área de intranet</h6>
                    <C030AreasDeIntranet 
                        class="p-0 m-0"
                        v-on:valorParaElPadre="evtCambioTipoArea" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="catalogoAreas.id" 
                        :parametros="catalogoAreas.parametros" 
                        :valorDefinido="catalogoAreas.areaId"></C030AreasDeIntranet>
                </div>
                <!-- FILTRO TIPO DE PAGINA INTRANET -->
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-1">
                    <h6 style="p-3">Página de intranet</h6>
                    <C029PaginasDeIntranet class="p-0 m-0" 
                        v-on:valorParaElPadre="cambioTipoDePagina" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="catalogoPaginas.id" 
                        :parametros="catalogoPaginas.parametros" 
                        :valorDefinido="catalogoPaginas.parametros.paginaId"
                        :key="catalogoPaginas.contRender + 'KEY-PAGINAS-FB'"></C029PaginasDeIntranet>
                </div>
                <!-- FILTRO TIPO DE SECCION -->
                <div v-if="this.campoRequeridoEsValido(catalogoPaginas.paginaId)" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-1">
                    <h6 style="p-3">Sección</h6>
                    <C024SeccionesDeIntranet
                        class="p-0 m-0"
                        v-on:valorParaElPadre="cambioTipoSeccion" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="catalogoSeccion.id" 
                        :parametros="catalogoSeccion.parametros" 
                        :valorDefinido="-1" 
                        :key="catalogoSeccion.contRender + 'KEY-SECCIONES-FB'"></C024SeccionesDeIntranet>
                </div>
                <!-- SECCIONES HIJAS -->
                <CSelectRecursivo class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3"
                    v-if="(mostrarSeccionesHijas) &&
                          (catalogoSeccion.seleccionada != null && (catalogoSeccion.seleccionada.SeccionesQueMePertenecen != null && catalogoSeccion.seleccionada.SeccionesQueMePertenecen.length > 0))"
                    v-on:SeleccionoElemento="cambioTipoSeccionHija"
                    :nodoPrincipal="catalogoSeccion.seleccionada"
                    :identificadores="{ nodosHijos: 'SeccionesQueMePertenecen', llave: 'SeccionDeIntranetId', nombre: 'Nombre' }"
                    :texoSingularEnSelect="'un tipo de seccion'"
                    :key="catalogoSeccion.hijos.KEY + catalogoSeccion.hijos.contRender"></CSelectRecursivo>
                <!-- SECCION PERMISOS -->
                <div v-if="!conAccionDeBusqueda && puedeRealizarAccion" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-2">
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-light btn-permisos" @click="evtObtenerSeccionParaPermisos"><i class="fas fa-plus"></i>&nbsp;&nbsp;Agregar permisos por puesto</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="conAccionDeBusqueda && puedeRealizarAccion" class="contenedor-principal-filtros acciones">
            <div id="seccion-acciones" class="d-flex justify-content-end">
                <button type="button" class="btn btn-primary mr-2" @click="evtAgregarNuevoContenido" v-tooltip:left="'Agregar nuevo contenido'"><i class="fas fa-plus"></i></button>
                <button type="button" class="btn btn-primary btn-green" @click="enviarParametros"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
            </div>
        </div>
    </div>
</template>
<script>
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
import CSelectRecursivo from '@/components/SICPO/Comun/CSelectRecursivo.vue'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import CArbolDeSeleccion from '@/components/SICPO/Intranet/Contenidos/CArbolDeSeleccion.vue';
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'

export default {
    props: {
        conAccionDeBusqueda: {
            type: Boolean,
            default: true
        },
        conEstilosClaros: {
            type: Boolean,
            default: false
        },
        conTitulo: {
            type: Boolean,
            default: true
        },
        escuchandoCambios: {
            type: Boolean,
            default: false
        },
    },
    components: {
        C030AreasDeIntranet: catalogos.SICPO.C030AreasDeIntranet,
        C029PaginasDeIntranet: catalogos.SICPO.C029PaginasDeIntranet,
        C024SeccionesDeIntranet: catalogos.SICPO.C024SeccionesDeIntranet,
        CSelectRecursivo: CSelectRecursivo,
        CArbolDeSeleccion: CArbolDeSeleccion
    },
    directives: {
        tooltipF
    },
    data() {
        return {
            enumeraciones,
            catalogoAreas: {
                id: 'catalogoAreasIntranet',
                parametros: {
                    Nombre: null,
                    ConAreasDePJ: true,
                    ConPaginas: false
                },
                areaId: -1,
                contRender: 0,
                seleccionada: null
            },
            catalogoPaginas: {
                id: 'catalogoPaginaIntranet',
                parametros: {
                    PaginaDeInicioId: null,
                    MenuId: null,
                    SubmenuId: null,
                    RutaDeAccesoDeLaPagina: null,
                    Titulo: null,
                    Activo: true,
                    ConAreasDeIntranet: false,
                    ConPaginaDeInicio: false,
                    ConMenu: false,
                    ConSubmenu: false,
                    ConSecciones: false,
                    areaDeIntranetId: null
                },
                paginaId: -1,
                contRender: 0,
                seleccionada: null
            },
            catalogoSeccion: {
                id: 'catalogoSeccionIntranet',
                parametros: {
                    PaginaWebId: null,
                    NombreSeccion: null,
                    MuestraNombreDeLaSeccion: null,
                    Titulo: null,
                    TextoDePresentacion: null,
                    TipoDeFormatoId: null,
                    Orden: null,
                    EstaEnEdicion: null,
                    SeccionALaQuePertenece: null,
                    EsActivo: null,
                    PermiteSubirContenido: null,
                    UsuarioQueEdita: null,
                    ConPaginaWeb: null,
                    ConTipoDeFormato: true,
                    ConSeccionALaQuePertenezco: null,
                    SeccionesQueMePertenecen: true,
                    ConContenido: null
                },
                seccionId: -1,
                contRender: 0,
                seleccionada: null,
                hijos: {
                    KEY: 'KEYSeccionHija-FB-ADMIN-CONT-ITR',
                    contRender: 0,
                    seleccionado: null,
                    historialDeSeleccion: []
                }
            },
            parametrosBusqueda: {
                paginaId: null,
                seccionId: null,
                paginaTitulo: null,
                seccionTitulo: null,
                formulario: null
            }
        }
    },
    methods: {
        evtObtenerSeccionParaPermisos: function() {
            let seccionObj = (this.seccionSeleccionadaEsValida() && (this.campoRequeridoEsValido(this.catalogoSeccion.hijos.seleccionado) && this.campoRequeridoEsValido(this.catalogoSeccion.hijos.seleccionado.SeccionDeIntranetId))) 
                    ? this.catalogoSeccion.hijos.seleccionado 
                    : this.campoRequeridoEsValido(this.catalogoSeccion.seleccionada) 
                        ? this.catalogoSeccion.seleccionada : null;
            this.$emit('getSeccionParaPermisos',seccionObj)
        },
        obtenerCamposDeFormulario: async function({ seccion }) {
            if(this.puedeRealizarAccion && this.campoRequeridoEsValido(seccion)) {
                await Promise.resolve(this.obtenerCamposDeFormularioBD({ seccionObj: seccion }));
                console.log('formulario::filtrosBusqueda::',this.parametrosBusqueda.formulario);
            }
        },
        obtenerCamposDeFormularioBD: async function({ seccionObj, conCargandoInformacion = true }) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.administracionDeContenidos.ObtenerCamposDeFormulario;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = {
                    SeccionDeIntranet: seccionObj,
                    esPrueba: false
                };
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(conCargandoInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_DE_PETICION = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_DE_RESPUESTA = await RESPUESTA_DE_PETICION.data;
                let { SiHayError, Error, Satisfactorio, Formulario } = DATOS_DE_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    this.parametrosBusqueda.formulario = Formulario;
                    comun.SeEstaCargandoInformacion(false);
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        evtCambioTipoArea: function(evento) {
            let nombreArea = evento.target[evento.target.selectedIndex].text;
            this.catalogoAreas.areaId = parseInt(evento.target.value);
            this.catalogoAreas.seleccionada = (this.campoRequeridoEsValido(this.catalogoAreas.areaId)) ?
                { AreaId: this.catalogoAreas.areaId, Nombre: nombreArea } :
                null;

            // limpia los valores del catalgo de paginas
            this.catalogoPaginas.paginaId = -1;
            this.catalogoPaginas.parametros.areaDeIntranetId = (this.campoRequeridoEsValido(this.catalogoAreas.areaId)) ? this.catalogoAreas.areaId : null;
            this.catalogoPaginas.contRender ++;

            // se asignan los parametros de secciones y se renderiza el catalogo
            this.catalogoSeccion.parametros.PaginaWebId = this.catalogoPaginas.paginaId;
            this.catalogoSeccion.contRender ++;
            this.catalogoSeccion.seccionId = -1;
            this.catalogoSeccion.seleccionada = null;

            // en caso de tener secciones hijas limpia los valores
            this.catalogoSeccion.hijos.historialDeSeleccion = [];
            this.catalogoSeccion.hijos.seleccionado = null;
            if(this.escuchandoCambios)
                this.$emit('seModificoSeleccion');
        },
        evtAgregarNuevoContenido: function() { 
            this.obtenerParametrosDeBusqueda();
            this.$emit('AgregarNuevoContenido', this.parametrosBusqueda);
        },
        enviarParametros: function() {
            this.obtenerParametrosDeBusqueda();
            this.$emit('RealizarBusquedaDeMenus', this.parametrosBusqueda);
        },
        obtenerParametrosDeBusqueda: function() { 
            this.parametrosBusqueda = {
                areaIntranetId: (this.campoRequeridoEsValido(this.catalogoAreas.areaId)) ? this.catalogoAreas.areaId : null,
                paginaId: (this.campoRequeridoEsValido(this.catalogoPaginas.paginaId)) ? this.catalogoPaginas.paginaId : null,
                seccionId: (this.seccionSeleccionadaEsValida() && (this.campoRequeridoEsValido(this.catalogoSeccion.hijos.seleccionado) && this.campoRequeridoEsValido(this.catalogoSeccion.hijos.seleccionado.SeccionDeIntranetId))) 
                    ? this.catalogoSeccion.hijos.seleccionado.SeccionDeIntranetId 
                    : this.campoRequeridoEsValido(this.catalogoSeccion.seccionId) 
                        ? this.catalogoSeccion.seccionId : null,
                paginaTitulo: this.catalogoPaginas.seleccionada.Titulo,
                seccionTitulo: this.catalogoSeccion.seleccionada.Nombre,
                formulario: this.parametrosBusqueda.formulario
            };
        },
        cambioTipoDePagina: function(evento, paginaObj) {
            this.catalogoPaginas.paginaId = parseInt(evento.target.value);
            this.catalogoPaginas.seleccionada = paginaObj;
            // se asignan los parametros de secciones y se renderiza el catalogo
            this.catalogoSeccion.parametros.PaginaWebId = this.catalogoPaginas.paginaId;
            this.catalogoSeccion.contRender ++;
            this.catalogoSeccion.seccionId = -1;
            this.catalogoSeccion.seleccionada = null;

            // en caso de tener secciones hijas limpia los valores
            this.catalogoSeccion.hijos.historialDeSeleccion = [];
            this.catalogoSeccion.hijos.seleccionado = null;

            if(this.escuchandoCambios)
                this.$emit('seModificoSeleccion');
        },
        cambioTipoSeccion: function(evento, seccionObj) {
            this.catalogoSeccion.seccionId = parseInt(evento.target.value);
            this.catalogoSeccion.seleccionada = seccionObj;

            // en caso de tener secciones hijas limpia los valores
            this.catalogoSeccion.hijos.historialDeSeleccion = [];
            this.catalogoSeccion.hijos.seleccionado = null;

            // se obtieenen los datos del formulario
            this.obtenerCamposDeFormulario({ seccion: seccionObj });

            if(this.escuchandoCambios)
                this.$emit('seModificoSeleccion');
        },
        cambioTipoSeccionHija: function(evento,objetoElemento) {
            this.catalogoSeccion.hijos.seleccionado = objetoElemento;

            // se obtieenen los datos del formulario
            this.obtenerCamposDeFormulario({ seccion: objetoElemento });

            if(this.escuchandoCambios)
                this.$emit('seModificoSeleccion');
        },
        // habilitar en caso de tener mas de una seccion hija (RECURSIVIDAD)
        /* cambioTipoSeccionHijaRecursiva: function(evento,objetoElemento) { 
            // se obtiene la informacion de la seccion padre
            let idSeccionPadreSTR = evento.target.getAttribute('id');
            let idCompuesto = idSeccionPadreSTR.split('-');
            let idSeccionPadre = parseInt(idCompuesto[idCompuesto.length -1]);

            // se asigna valor de la seccion a objeto
            this.catalogoSeccion.hijos.seleccionado = objetoElemento;

            // caso donde la seleccion tiene un valor
            if(this.campoRequeridoEsValido(objetoElemento)) {
                let seccionPrevia = this.catalogoSeccion.hijos.historialDeSeleccion.find(sh => sh.SeccionALaQuePertenezco.SeccionDeIntranetId == objetoElemento.SeccionALaQuePertenezco.SeccionDeIntranetId);
                if(!this.campoRequeridoEsValido(seccionPrevia))
                    this.catalogoSeccion.hijos.historialDeSeleccion.push(objetoElemento);
                else {
                    seccionPrevia = objetoElemento;

                    // se eliminan historial de secciones hijas
                    let indexDeElemento = this.catalogoSeccion.hijos.historialDeSeleccion.findIndex(sh => sh.SeccionALaQuePertenezco.SeccionDeIntranetId == objetoElemento.SeccionALaQuePertenezco.SeccionDeIntranetId);
                    indexDeElemento ++; // metodo slice termina uno antes del parametro que se le mande como final por eso se suma 1
                    this.catalogoSeccion.hijos.historialDeSeleccion = this.catalogoSeccion.hijos.historialDeSeleccion.slice(0,indexDeElemento);
                }
            }
            else if(this.catalogoSeccion.hijos.historialDeSeleccion.length > 0){
                const ELEMENTO_SELECCIONADO = this.catalogoSeccion.hijos.historialDeSeleccion.find(sh => sh.SeccionALaQuePertenezco.SeccionDeIntranetId == idSeccionPadre);

                if(this.campoRequeridoEsValido(ELEMENTO_SELECCIONADO)) {
                    // se eliminan historial de secciones hijas
                    let indexDeElemento = this.catalogoSeccion.hijos.historialDeSeleccion.findIndex(sh => sh.SeccionALaQuePertenezco.SeccionDeIntranetId == idSeccionPadre);
                    indexDeElemento ++; // metodo slice termina uno antes del parametro que se le mande como final por eso se suma 1
                    this.catalogoSeccion.hijos.historialDeSeleccion = this.catalogoSeccion.hijos.historialDeSeleccion.slice(0,indexDeElemento);

                    // se elimina seleccion actual
                    this.catalogoSeccion.hijos.historialDeSeleccion = this.catalogoSeccion.hijos.historialDeSeleccion.filter(sh => !sh.SeccionALaQuePertenezco.SeccionDeIntranetId == ELEMENTO_SELECCIONADO.SeccionALaQuePertenezco.SeccionDeIntranetId);
                }
            }
        }, */
        // habilitar en caso de tener mas de una seccion hija (RECURSIVIDAD)
        /* obtenerUltimaSeleccionValidaHijosDeSeccion: function() {
            const ULTIMO_INDEX = (this.catalogoSeccion.hijos.historialDeSeleccion.length - 1);
            let ultimaSeleccionValida = this.catalogoSeccion.hijos.historialDeSeleccion[ULTIMO_INDEX];
            return ultimaSeleccionValida;
        }, */
        seccionSeleccionadaEsValida: function() {
            let esValida = false;
            // se valida si la seccion seleccionada no esta nula
            if(this.campoRequeridoEsValido(this.catalogoSeccion.seleccionada)) {
                // se valida si la seccion tiene seccionas hijas
                if(this.campoRequeridoEsValido(this.catalogoSeccion.seleccionada.SeccionesQueMePertenecen) && this.catalogoSeccion.seleccionada.SeccionesQueMePertenecen.length > 0) 
                    esValida = (this.campoRequeridoEsValido(this.catalogoSeccion.hijos.seleccionado) && this.catalogoSeccion.hijos.seleccionado.PermiteSubirContenido);
                else
                    esValida = this.catalogoSeccion.seleccionada.PermiteSubirContenido;
            }
            return esValida;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
    },
    computed: {
        obtenerSeccionesHijas() {
            return this.catalogoSeccion.hijos.historialDeSeleccion;
        },
        puedeRealizarAccion() {
            return (this.campoRequeridoEsValido(this.catalogoPaginas.paginaId) && 
                    this.seccionSeleccionadaEsValida() &&
                    this.campoRequeridoEsValido(this.catalogoAreas.areaId));
        },
        mostrarSeccionesHijas() {
            return (this.campoRequeridoEsValido(this.catalogoSeccion.seleccionada) && 
                   (this.campoRequeridoEsValido(this.catalogoSeccion.seleccionada.SeccionesQueMePertenecen) && this.catalogoSeccion.seleccionada.SeccionesQueMePertenecen.length > 0));
        },
        informacionDePunteroCompleta() {
            return (this.campoRequeridoEsValido(this.catalogoPaginas.seleccionada) && this.campoRequeridoEsValido(this.catalogoSeccion.seleccionada) && this.campoRequeridoEsValido(this.catalogoAreas.seleccionada));
        }
    },
    watch: {
        'parametrosBusqueda.formulario': function() {
            console.log('filtrosBusqueda::cambio::formulario::',this.parametrosBusqueda.formulario);
        }
    }
}
</script>
<style scoped>
.btn-green{
    background-color: var(--verde-pj-100);
}
.btn-green:hover{
    background-color: var(--verde-pj);
}
#puntero-de-seleccion-info ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: relative;
}

#puntero-de-seleccion-info li {
  list-style-type: none;
  border-left: 2px solid #000;
  margin-left: 1em;
}

#puntero-de-seleccion-info li div {
  padding-left: 1em;
  position: relative;
}

#puntero-de-seleccion-info li div::before {
  content:'';
  position: absolute;
  top: 0;
  left: -2px;
  bottom: 50%;
  width: 0.75em;
  border: 2px solid #000;
  border-top: 0 none transparent;
  border-right: 0 none transparent;
}

#puntero-de-seleccion-info ul > li:last-child {
  border-left: 2px solid transparent;
}

.acciones {
    border-top: 2px solid rgb(27, 27, 27);
    background-color: #444444;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

#seccion-acciones {
    padding: 1em 1em 1em 1em;
}

#seccion-acciones .btn {
    padding: 0.3em 0.8em 0.3em 0.8em;
    font-size: 2.1vmin;
    background-color: black;
}

.titulo-contenedores h5 {
    font-size: 2.7vmin;
}

.titulo-contenedores {
    background-color: var(--verde-pj);
    padding: 1.3em 2em 0.5em 2em;
    color: white;
    border-bottom: 1px solid rgb(27, 27, 27);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.titulo-contenedores-calro h5 {
    font-size: 2.7vmin;
}

.titulo-contenedores-claro {
    background-color: #212529;
    padding: 1.3em 2em 0.5em 2em;
    color: white;
    border-bottom: 1px solid #212529;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.contenedor-color-negro {
    background-color: var(--gris-pj-100);
    padding: 25px;
    border: 1px solid rgb(27, 27, 27);
    border-radius: 4px;
    color: #000;
}

.contenedor-color-claro {
    padding: 25px;
    border-radius: 4px;
    border: 2px solid rgb(27, 27, 27);
}

.btn-permisos {
    background-color: #212529;
    color: white;
    border: 1px solid #212529;
}

.btn-permisos:hover {
    background-color: #0c0e0f;
    color: white;
    border: 1px solid #0c0e0f;
}

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Intranet/Contenidos/CFiltrosDeBusqueda.vue